import * as React from 'react';
import { Helmet } from 'react-helmet';
import { ExclamationTriangleIcon } from '@patternfly/react-icons';
import { PageSection, Title, Button, EmptyState, EmptyStateIcon, EmptyStateBody } from '@patternfly/react-core';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import './not-found.css'; // Import custom styles

const NotFound: React.FC = () => {
  const dispatch = useDispatch();
  const [showNotFound, setShowNotFound] = React.useState(false);
  
  // Add a delay before showing 404 page to prevent flashing during loading
  React.useEffect(() => {
    // Find and disable any loader elements
    const disableLoaders = () => {
      const loaders = document.querySelectorAll('.loader, .loader-wrapper');
      loaders.forEach(loader => {
        if (loader instanceof HTMLElement) {
          loader.style.display = 'none';
        }
      });
    };

    // Run immediately and then after a delay
    disableLoaders();
    
    const timer = setTimeout(() => {
      disableLoaders(); // Run again before showing content
      setShowNotFound(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = React.useCallback(() => {
    dispatch(push('/dashboard'));
  }, [dispatch]);

  // Return a completely blank screen during the initial delay, with styles to hide any loaders
  if (!showNotFound) {
    return (
      <div className="notfound-blank-screen"></div>
    );
  }

  return (
    <PageSection data-testid="not-found">
      <Helmet>
        <title>
          404 Not Found
        </title>
      </Helmet>
      <EmptyState variant="full">
        <EmptyStateIcon icon={ExclamationTriangleIcon} />
        <Title headingLevel="h1" size="lg">
          404 Page not found
        </Title>
        <EmptyStateBody>
          We didn&apos;t find a page that matches the address you navigated to.
        </EmptyStateBody>
        <Button onClick={handleClick}>Go to Dashboard</Button>
      </EmptyState>
    </PageSection>
  )
};

export { NotFound };
